import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "count"]
  static values = { url: String, voted: Boolean, count: Number }

  connect() {
    this.syncUI()
  }

  async toggle() {
    const wasVoted = this.votedValue
    const oldCount = this.countValue

    // Optimistic update
    this.votedValue = !wasVoted
    this.countValue = wasVoted ? Math.max(oldCount - 1, 0) : oldCount + 1
    this.syncUI()

    // Animate only on vote (not unvote)
    if (!wasVoted) {
      this.animatePop()
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const data = await response.json()
      this.votedValue = data.voted
      this.countValue = data.count
      this.syncUI()
    } catch {
      // Rollback on failure
      this.votedValue = wasVoted
      this.countValue = oldCount
      this.syncUI()
    }
  }

  syncUI() {
    this.element.classList.toggle("is-voted", this.votedValue)
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.countValue > 0 ? this.countValue : ""
    }
  }

  animatePop() {
    if (!this.hasIconTarget) return
    this.iconTarget.classList.remove("is-animating")
    // Force reflow to restart animation
    void this.iconTarget.offsetWidth
    this.iconTarget.classList.add("is-animating")
    this.iconTarget.addEventListener("animationend", () => {
      this.iconTarget.classList.remove("is-animating")
    }, { once: true })
  }
}
